<template>
  <v-container>
    <loader-dialog :showLoader="loading" message="Carregando setores..."/>
    <header-for-list-component
      sectionName="Setores"
      :items="activeItems"
      :totalItems="totalItems"
      :totalPages="totalPages"
      :itemsPerPage="itemsPerPage"
      :pageNumber.sync="pageNumber"
      @loadPage="loadPage($event)"
    />

    <v-layout align-center class="mb-4">
      <v-flex xs4>
        <v-text-field
          v-model="search"
          solo
          label="Buscar setor"
          prepend-inner-icon="search"
          hide-details
          :loading="loadingSearch"
          @input="typing()"
        >
          <template v-slot:progress>
            <v-progress-linear
              v-if="loadingSearch"
              color="accent"
              indeterminate
              height="3"
            ></v-progress-linear>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex xs8></v-flex>
      <v-flex>
        <v-btn flat color="docgo" @click.stop="newAdministrativeUnit()">
          <v-icon class="pr-2">
            mdi-account-multiple-plus
          </v-icon>
          Novo Setor
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <v-card>
          <div v-if="activeItems.length === 0">
            <h4 style="text-align: center" class="pa-3">Nenhum setor encontrado com o termo buscado</h4>
          </div>

          <v-data-table
            v-else
            :headers="headers"
            :items="activeItems"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr style="cursor: default">
                <td>
                  <span class="">{{ props.item.id }}</span>
                </td>
                <td>
                  <span class="">{{ props.item.name }}</span>
                </td>
                <td class="text-xs-right action-icons">
                  <v-layout class="d-inline-flex">
                    <v-btn
                      icon
                      flat
                      class="mx-0"
                      @click.stop="editAdministrativeUnit(props.item)"
                    >
                      <v-icon small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>

          <administrative-unit-form v-if="showDialogAdministrativeUnit" :dialog.sync="showDialogAdministrativeUnit" @updateList="loadPage()"/>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import HeaderForListComponent from "@/components/settings/HeaderForListComponent";
  import LoaderDialog from '@/components/LoaderDialog';
  import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';
  import FolderTransferDialog from '@/components/folder/entity/FolderTransferDialog';
  import AdministrativeUnitForm from '@/components/administrative_unit/AdministrativeUnitForm';

  import { trim } from 'lodash';

  export default {
    components: {
      LoaderDialog,
      HeaderForListComponent,
      AdministrativeUnitForm
    },
    name: "administrative_units",
    data() {
      return {
        headers: [
          {text: 'ID', sortable: true, value: 'id', align: 'left'},
          {text: 'Nome', sortable: false, value: 'name', align: 'left'},
        ],
        activeItems: [],
        showDialogAdministrativeUnit: false,
        loading: false,
        loadingSearch: false,
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 20,
        pageNumber: 1,
        search: '',
        interval: null,
      };
    },
    mounted() {
      this.loadPage(1);
    },
    methods: {
      loadPage(pageNumber) {
        this.pageNumber = pageNumber || this.pageNumber;
        if (!this.loadingSearch) this.loading = true;

        AdministrativeUnitService.all({
          limit: this.itemsPerPage,
          page: this.pageNumber,
          q: this.search,
        })
          .then(({data}) => {
            this.activeItems = data.administrative_units;
            this.totalItems = data.total;
            this.totalPages = data.total_pages;
          })
          .catch(({response}) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 6000,
              color: 'error',
              message: response.data,
              messageIcon: 'mdi-check',
            });
          })
          .finally(() => {
            this.loading = false;
            this.loadingSearch = false;
          });
      },
      typing() {
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          this.pageNumber = 1;
          this.loadPage();
        }, 500);
      },
      editAdministrativeUnit(administrativeUnit) {
        this.$store.dispatch('setAdministrativeUnit', administrativeUnit);
        this.showDialogAdministrativeUnit = true;
      },
      newAdministrativeUnit() {
        this.$store.dispatch('setAdministrativeUnit', {});
        this.showDialogAdministrativeUnit = true;
      },
    }
  };
</script>

<style lang="scss" scoped>
  .inactive{
    & > * {
      text-decoration: line-through;
    }
  }

  .action-icons{
    text-decoration: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/settings/administrative_units/List.vue